<script setup lang="ts">
import { ref, computed } from 'vue'
import Modal from '@/components/Modal.vue'
import MIcon from '@/components/MIcon.vue'

interface Props {
  modalType?: 'error' | 'warning' | 'success'
  title?: string
  description?: string
  cancelButtonText?: string
  confirmButtonText?: string
  onCancel?: () => void
  onConfirm?: () => void
}

const props = withDefaults(defineProps<Props>(), {
  modalType: 'success',
  cancelButtonText: '',
  confirmButtonText: 'Tamam',
})

const modalRef = ref<InstanceType<typeof Modal>>()

const modalColor = computed(() => {
  return props.modalType === 'error' ? 'text-rose-600' : 'text-blue-600'
})
const modalBgColor = computed(() => {
  return props.modalType === 'error' ? 'bg-rose-50' : 'bg-blue-50'
})
const closeModal = () => {
  modalRef.value?.closeModal()
}

const handleCancel = () => {
  closeModal()
  if (props.onCancel) {
    props.onCancel()
  }
}

const handleConfirm = () => {
  if (props.onConfirm) {
    props.onConfirm()
  }
  closeModal()
}

defineExpose({
  openModal: () => modalRef.value?.openModal(),
  closeModal,
})
</script>

<template>
<!-- todo: Modalın hizasına basınca kapanmıyor detaylı test edilmesi gerekli-->
  <Modal ref="modalRef">
    <div class="card p-4 flex flex-col items-center justify-center max-w-sm mx-auto rounded-4xl">
      <span class="flex items-center justify-center w-10 h-10 rounded-full mb-4" :class="modalBgColor">
        <MIcon :name="modalType === 'success' ? 'check_circle' : 'error'" size="20px" :class="modalColor" />
      </span>

      <h1 class="text-title-md" :class="modalColor">{{ title }}</h1>

      <p class="text-body-md text-gray-700 text-center mt-2 text-pretty">
        {{ description }}
      </p>

      <div class="flex items-center justify-between w-full gap-2 mt-10">
        <button v-if="cancelButtonText" class="btn btn-status-default w-full" @click="handleCancel">
          {{ cancelButtonText }}
        </button>
        <button class="btn w-full" :class="modalType === 'error' ? 'btn-danger-filled' : 'btn-primary'" @click="handleConfirm">
          {{ confirmButtonText }}
        </button>
      </div>
    </div>
  </Modal>
</template>
